<mat-toolbar color="accent">Edit MOH Practice Settings</mat-toolbar>

<div class="p-4">
  <pr-information-box>
    <p>Please enter required MOH Practice settings to continue claiming.</p>
    Missing fields:
    @for (field of missingFields; track field; let i = $index) {
      {{ field }}{{ i < missingFields.length - 1 ? ', ' : '' }}
    }
  </pr-information-box>

  <pr-practice-moh-settings
    [practice]="practice"
    (formSaved)="dialogRef.close(practice)"
  />
</div>
